import { environment as productionEnvironment } from './environment.prod';

export const environment = {
  ...productionEnvironment,
  name: 'tst',
  production: false,
  enableSentry: false,
  firebase: {
    projectId: 'tracit-tst',
    appId: '1:454347597427:web:cb5a3853020c79a52e6c06',
    storageBucket: 'tracit-tst.appspot.com',
    locationId: 'australia-southeast1',
    apiKey: 'AIzaSyDpnx5Z2AGOjgamxh_sD0K9_bD4QJEG640',
    // Matches the domain the test site is served on, for the reasons in environment.prod.ts.
    authDomain: 'test.app.tracit.com.au',
    messagingSenderId: '454347597427',
    measurementId: 'G-KNVZ4LG7DL',
  },
  recaptchaEnterpriseSiteKey: '6LfdS4otAAAAAHDKcdhtXV-nInGFyr84Nqjdsu6M',
  appCheckFailureLogUrl: 'https://australia-southeast1-tracit-tst.cloudfunctions.net/logAppCheckFailure',
  publicAssetsBaseUrl: 'https://storage.googleapis.com/tracit-tst-public-assets',
  searchIndexes: {
    agents: 'tst_AGENTS',
    groups: 'tst_GROUPS',
    trainers: 'tst_TRAINERS',
  },
};
